<template>
  <div class="input-group ms-2">
    <span class="input-group-text text-body">
      <i class="fas fa-search" aria-hidden="true"></i>
    </span>
    <input v-model="texto" class="form-control" :placeholder="$t('key_text_search')" type="text" @input="changeInput()" />
    <span v-if="texto" class="input-group-text text-body" @click="clearInput()">
      <i class="fas fa-xmark" aria-hidden="true" ></i>
    </span>
  </div>
</template>

<script>

  export default {
    name: "Searchable",
    props: {
      listFilters: {
        type: Object,
        default: null
      }
    },
    emits: ['change'],
    data() {
      return {
        texto: ""
      }
    },
    watch: {
      // texto(val) {
      //   this.$emit('change', val);
      // },
      listFilters(){
        if (this.listFilters['filters']['search']) {
          this.texto = this.listFilters['filters']['search']
        }
      }
    },
    methods: { 
      changeInput() {
        this.$emit('change', this.texto);
      },
      clearInput() {
        this.texto = '';
        this.$emit('change', this.texto);
      }
    }
  };

</script>